import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const PageStack = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 16"
      style={style}
    >
      <title>Page Stack Icon</title>
      <path d="M13.69 3.369L10.294 0h-6.46v1.778H2.042v1.778H.25V16h9.856v-1.778h1.792v-1.778h1.792V3.37zm-3.584-2.293l2.5 2.48h-2.5v-2.48zM9.21 15.11H1.146V4.444h.896v9.778H9.21v.89zm1.792-1.778H2.938V2.667h.896v9.777h7.168v.89zm.896-1.777H4.73V.889h4.48v3.555h3.584v7.112h-.896z" />
    </svg>
  );
};

PageStack.defaultProps = {
  width: '14px',
  height: '16px',
  style: {},
};

export default PageStack;
